import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formatiert die übergebene Nummer in einen lokalisierten String zur Wiedergabe im Frontend
 */
@Pipe({ name: 'nbInvoiceNumber' })
export class NbInvoiceNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (value !== null) {
      return value;
    }

    return '-';
  }
}